module.exports = __webpack_public_path__ + "static/media/skrill.fd19a8ae.png";